import { render, staticRenderFns } from "./CmgMealBuilderItemSelectorCardCustomizationButton.vue?vue&type=template&id=18ac5938&scoped=true&lang=pug&"
import script from "./cmg-meal-builder-item-selector-card-customization-button.ts?vue&type=script&lang=ts&"
export * from "./cmg-meal-builder-item-selector-card-customization-button.ts?vue&type=script&lang=ts&"
import style0 from "./CmgMealBuilderItemSelectorCardCustomizationButton.vue?vue&type=style&index=0&id=18ac5938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ac5938",
  null
  
)

export default component.exports